/**
 * 管理所有的弹窗模块
 * @author lianghua.fu
 * @date 2020-12-01 10:03:53
 */
import React, {useEffect, useLayoutEffect} from "react"

import {observer} from "mobx-react";
import {useGlobalStore} from "stores";

type Modal = {
  key: string,
  Com: React.ElementType
}

const Modals = observer(({children}: any) => {


  let {modal, position} = useGlobalStore()


  return <div id="page_popup">
    {
      modal.modals.map(({key, Com}: Modal) => {
        return <Com key={ key }/>
      })
    }
  </div>
})

export default Modals



